/**
 * 赠送弹框
 */

import * as React from 'react'
import { useModalWrap } from '@/components'
// import { getLoginStatus } from '@/utils'
// import {
//   setUserStorage,
//   getUserStorage,
//   setCompanyStorage,
//   getCompanyStorage,
// } from '@/services/common'
import config from '@/utils/config'
import Content from './Content'
import usePageType, { PAGE_TYPES } from '@/hooks/usePageType'
import gioTrackEvent from '@/utils/gio'
import styles from './index.module.less'

const { useEffect } = React

const storageKey: string = 'gift-notice-flag'

export default function useInquiryModal() {
  const pageType = usePageType()
  const handleClose = () => {}

  const { showModal, hideModal, render, visible } = useModalWrap({
    modalProps: {
      title: null,
      // width: 360,
      bodyStyle: { padding: 0 },
      footer: null,
      maskClosable: false,
      afterClose: handleClose,
      onCancel: (cb: () => void) => {
        cb?.()
      },
      className: styles['gift-modal-warper'],
    },
    children: (props: any) => <Content {...props} />,
  })

  useEffect(() => {
    if (visible) {
      // 埋点
      if (PAGE_TYPES['EDM_EC'] === pageType) {
        gioTrackEvent('EDM_EC_Landingpage_bonus_pageView')
      } else if (PAGE_TYPES['EDM_GAME'] === pageType) {
        gioTrackEvent('EDM_Game_Landing_bonus_pageView')
      } else if (PAGE_TYPES['EDM_APP'] === pageType) {
        gioTrackEvent('EDM_APP_Landingpage_bonus_pageView')
      } else if (PAGE_TYPES['EDM_GENERAL'] === pageType) {
        gioTrackEvent('EDM_general_Landingpage_bonus_pageView')
      } else if (PAGE_TYPES['WECHAT_GENERAL'] === pageType) {
        gioTrackEvent('Wechat_general_Landingpage_bonus_pageView')
      }
    }
  }, [visible])

  return {
    showModal,
    render,
    hideModal,
  }
}
